import { render, staticRenderFns } from "./Choropleth.vue?vue&type=template&id=486da319&scoped=true&"
import script from "./Choropleth.vue?vue&type=script&lang=js&"
export * from "./Choropleth.vue?vue&type=script&lang=js&"
import style0 from "./Choropleth.vue?vue&type=style&index=0&id=486da319&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486da319",
  null
  
)

export default component.exports